"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = systemAdmin;
function systemAdmin(user) {
  return user && user.isAdmin;
}